import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function NotFound() {
  const { isSuperAdmin, isMosqueAdmin } = useAuth();
  const navigate = useNavigate();

  const home = isSuperAdmin ? '/superadmin' : isMosqueAdmin ? '/admin' : '/login';

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg, #F7F5F0)', padding: 24, textAlign: 'center',
    }}>
      <div style={{ fontSize: 80, fontWeight: 800, color: 'var(--primary, #5B8A75)', lineHeight: 1 }}>
        404
      </div>
      <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--text, #1a1a2e)', marginTop: 16, marginBottom: 8 }}>
        Seite nicht gefunden
      </div>
      <div style={{ fontSize: 14, color: 'var(--text3, #9ca3af)', marginBottom: 32, maxWidth: 340 }}>
        Die angeforderte Seite existiert nicht oder wurde verschoben.
      </div>
      <button
        className="btn btn-primary"
        onClick={() => navigate(home)}
        style={{ padding: '10px 28px' }}
      >
        Zur Startseite
      </button>
    </div>
  );
}
